import dateFormat from "dateformat";
import PropTypes from "prop-types";
import React, { ReactElement, useEffect, useState } from "react";
import { CustomerBooking } from "rsl-api-106/lib/types";
import Cookies from "universal-cookie";

type UCatchItTrackingProps = {
  reservation: CustomerBooking;
};

const UCatchItTracking: React.FC<UCatchItTrackingProps> = ({ reservation }) => {
  const [img, setImg] = useState<ReactElement | null>(null);

  useEffect(() => {
    if (reservation) {
      init();
    }
  }, []);

  const init = () => {
    const cookies = new Cookies();
    let cookie = cookies.get("tag_uci");
    if (cookie && cookie != null) {
      let name = reservation.property?.label!!;
      let name_replace = name.replace(/[^a-zA-Z0-9]/gi, "-");
      let libelle_type_hebergement = getRoomReservationLabel();
      let libelle_type_hebergement_replace = libelle_type_hebergement.replace(
        /[^a-zA-Z0-9]/gi,
        "-"
      );

      let imgSrc =
        "https://ucatchit-tracking.location-vacances-express.com/cgi-bin/tagstock?event=reservation&site=Vacanceole&produit=" +
        name_replace +
        "-" +
        libelle_type_hebergement_replace +
        "&langue=fr&http_referrer=Vacanceole&account=PLVE-UCI&marque=LVE-EXPRESS&montant=" +
        reservation.totalAmount?.amount +
        "&type=comission&numero=" +
        reservation.id +
        "&date_debut_sejour=" +
        dateFormat(new Date(reservation.startDate), "yyyy-mm-dd") +
        "&date_fin_sejour=" +
        dateFormat(new Date(reservation.endDate), "yyyy-mm-dd") +
        "&tag_uci=" +
        cookie +
        "&page=commande";

      let img = React.createElement("img", {
        src: imgSrc,
        width: 1,
        height: 1,
        border: 0,
      });

      setImg(img);
    }
  };

  const getRoomReservationLabel = (): string => {
    let code: string[] = [];
    reservation?.stays?.forEach((stay) => {
      stay?.distribution?.roomTypes?.forEach((ri) => {
        code = [...code, ri?.label ?? ""];
      });
    });
    return code.join(" / ");
  };

  return img ? img : <></>;
};

UCatchItTracking.propTypes = {
  //
};

export default UCatchItTracking;
